import type {ModalAction, PopoverAction} from '@packages/systems/overlays';

export type Mode =
  | 'external'
  | 'page'
  | 'section'
  | 'email'
  | 'tel'
  | 'file'
  | 'dynpage'
  | 'popover'
  | 'modal';

export enum LINK_TYPES {
  EXTERNAL = 'external',
  DYNPAGE = 'dynpage',
  PAGE = 'page',
  SECTION = 'section',
  EMAIL = 'email',
  TELEPHONE = 'tel',
  FILE = 'file',
  POPOVER = 'popover',
  MODAL = 'modal',
}

export type State = {
  mode: Mode;
  url?: string;
  pageId?: string;
  pageSlug?: string;
  collectionId?: string;
  itemId?: string;
  domId?: string;
  email?: string;
  subject?: string;
  tel?: string;
  assetId?: string;
  assetUrl?: string;
  target?: '_self' | '_blank';
  preload?: 'none' | 'prefetch' | 'prerender';
  popoverTarget?: string;
  popoverTargetComponent?: string;
  popoverAction?: PopoverAction;
  modalTarget?: string;
  modalTargetComponent?: string;
  modalAction?: ModalAction;
};

export type ChangeTypes =
  | 'changeStart'
  | 'change'
  | 'changeEnd'
  | 'changeCancel';
